import {
  MainnetLockingContract,
  PulseLockingContract,
  PulseTestLockingContract,
  TestLockingContract,
  TestMainWaitContract,
  TestWaitContract,
  WaitContract,
} from 'libs/data/contracts'
import { useChainId } from 'wagmi'

import useLocked from './useLocked'
import useWrite from './useWrite'

export default (number, func): any => {
  const locked = useLocked()
  const chainId = useChainId()
  const addr =
    process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
      ? PulseTestLockingContract.address
      : chainId == 5 && process.env.NEXT_PUBLIC_ENV == 'development'
        ? TestLockingContract.address
        : chainId == 1
          ? MainnetLockingContract.address
          : PulseLockingContract.address
  const abi =
    process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
      ? PulseTestLockingContract.abi
      : chainId == 5 && process.env.NEXT_PUBLIC_ENV == 'development'
        ? TestLockingContract.abi
        : chainId == 1
          ? MainnetLockingContract.abi
          : PulseLockingContract.abi
  const waitAddress =
    process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
      ? TestWaitContract.address
      : chainId == 5 && process.env.NEXT_PUBLIC_ENV == 'development'
        ? TestMainWaitContract.address
        : process.env.NEXT_PUBLIC_ENV != 'development'
          ? WaitContract.address
          : WaitContract.address

  return useWrite({
    contract: addr,
    abi: abi,
    functionName: 'unlockSome',
    loading: locked.state === 'loading',
    enabled: true,
    args: [waitAddress, number],
    onTransactionComplete: () => {
      func()
    },
  })
}
